module.exports = __webpack_public_path__ + "img/hat-1.8372169d.svg";